import { FormattedMessage } from "react-intl";

const WithdrawalMessage = ({ id }) => (
  <div className="first-time-withdrawal">
    <FormattedMessage tagName="span" id={id} />
  </div>
);

export default WithdrawalMessage;
